import{__module as r}from"../../../../_virtual/arrayLikeToArray.js";var e;(e=r).exports=function(r,e){(null==e||e>r.length)&&(e=r.length);for(var o=0,t=Array(e);o<e;o++)t[o]=r[o];return t},e.exports.__esModule=!0,e.exports.default=e.exports;
//# sourceMappingURL=arrayLikeToArray.js.map
